import React, { useEffect, useRef } from 'react'
import { COOKIE, getCookie } from '../../../services/cookie';
import ReactHlsPlayer from 'react-hls-player';

function VideoHlsPlayer({ videoDetails, apiUrl}) {
	
	const playerRef = useRef(null);
	const playerConfig = {
		minAutoBitrate: 0,
		hlsConfig: {
			xhrSetup: (xhr) => {
				// Add custom headers
				xhr.setRequestHeader('Authorization', `Bearer ${getCookie(COOKIE.Token)}`);
			}
		}
	};
	if (!videoDetails?.filename) return null;
  return (
		  <ReactHlsPlayer
			  playerRef={playerRef}
			  src={`${apiUrl}/${videoDetails?.filename}/index.m3u8`}
			  autoPlay={true}
			  controls={true}
			  className="w-full md:max-h-[70vh]"
			  {...playerConfig}
			  onContextMenu={(e) => e.preventDefault()}
			  controlsList='nodownload'
		  />
  )
}

export default VideoHlsPlayer
